<template>
  <!-- <div v-if="show">
    <ContactUs />
  </div> -->
  <ContactNew></ContactNew>
</template>

<script setup>
import ContactNew from '~/components/Contact/ContactNew.vue';

const { t } = useI18n();

const route = useRoute();
const ogUrl = computed(() => `https://cld.eu${route.fullPath}`);

useHead({
  title: t('seo.contact_call_to_action'),
  meta: [
    {
      property: 'og:title',
      content: t('seo.contact_call_to_action'),
    },
    {
      property: 'og:description',
      content: t('seo.contact_desc'),
    },
    {
      property: 'og:url',
      content: ogUrl.value,
    },
    {
      name: 'description',
      content: t('seo.contact_desc'),
    },
    {
      property: "og:type",
      content: "website"
    },
    {
      property: "og:image",
      content: ""
    },
    {
      property: "og:site_name",
      content: "CLD Distribution"
    },

  ],
});

// const show = ref(false)
// onMounted(() => {
//   setTimeout(() => {
//     show.value = true
//   }, 2000);
// })
</script>

<style scoped></style>